import * as React from 'react';
import cn from 'classnames';
import { ReadMoreLink } from '../ReadMoreLink';
import { ContainerLayout } from '../ContainerLayout';
import { Button, useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { ErrorText } from '../ErrorText';
import { NBSP } from '../../../../constants/symbols';
import { TButtonTheme } from '@cian/ui-kit/button/types';

interface IFinalStepQuestionLayoutProps {
  onButtonClick: () => void;
  changeLabelButtonText: string;
  changeLabelButtonTheme: TButtonTheme;
  isLoading: boolean;
  isError: boolean;
}

export const FinalStepQuestionLayout: React.FC<IFinalStepQuestionLayoutProps> = ({
  onButtonClick,
  changeLabelButtonText,
  changeLabelButtonTheme,
  isLoading,
  isError,
}) => {
  const isMobile = useDeviceType() === 'phone';

  return (
    <ContainerLayout
      title="На вашем объявлении будет значок"
      content={
        <div className={cn(styles['content'], isMobile && styles['content-mobile'])}>
          Он покажет, что с вашим объектом можно провести онлайн-сделку, но не обязывает делать это через наш сервис.
          {NBSP}
          {isMobile && <ReadMoreLink inline theme="not-filled" />}
        </div>
      }
      actions={
        <>
          <Button loading={isLoading} onClick={onButtonClick} theme={changeLabelButtonTheme}>
            {changeLabelButtonText}
          </Button>
          {!isMobile && <ReadMoreLink theme="not-filled" />}
          {isError && <ErrorText />}
        </>
      }
      isWithRightSideImage={false}
      isWithRingLabelImage
      actionsGap={16}
    />
  );
};
